import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-shoe-change',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './shoe-change.component.html',
    styleUrl: './shoe-change.component.scss'
})
export class ShoeChangeComponent {}
